export default __webpack_public_path__ + "static/media/searchIcon.e6d20927.svg";